import React from "react";
import type { SolutionFeedbackFieldProps } from "../../../../../../../../types/feedback/feedback";
import CustomSelect from "../../../../../../../common/custom-select";

const BuyingSignalField: React.FC<SolutionFeedbackFieldProps> = ({ formState, setFormState }) => {
  if (formState.impactResponse !== "yes" && formState.impactResponse !== "partially") return null;
  return (
    <div>
      <label className="block text-[16px] font-medium text-brand-textSubheading mb-[24px]">
        What would you likely do next?
      </label>
      <CustomSelect
        options={[
          { label: "Ignore this", value: "ignore" },
          { label: "Bookmark it", value: "bookmark" },
          { label: "Share internally", value: "share_internally" },
          { label: "Pilot it", value: "pilot" },
          { label: "Actively pursue a solution", value: "actively_pursue" },
        ]}
        selectedValue={formState.buyingSignal}
        onChange={(value) => setFormState((prev) => ({ ...prev, buyingSignal: value }))}
        placeholder="Select your likely next step..."
      />
    </div>
  );
};

export default BuyingSignalField;
